import { useEffect, useState } from "react";

// Fångar installationsprompten globalt (måste ske innan React hinner montera)
let deferredPrompt = null;
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    window.dispatchEvent(new Event("pwa-installable"));
  });
}

export function usePwaInstall() {
  const isIos = typeof navigator !== "undefined" && /iphone|ipad|ipod/i.test(navigator.userAgent);
  const isStandalone = typeof window !== "undefined" &&
    (window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true);
  const [canInstall, setCanInstall] = useState(!!deferredPrompt);
  useEffect(() => {
    const on = () => setCanInstall(true);
    const off = () => setCanInstall(false);
    window.addEventListener("pwa-installable", on);
    window.addEventListener("appinstalled", off);
    return () => { window.removeEventListener("pwa-installable", on); window.removeEventListener("appinstalled", off); };
  }, []);
  const promptInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      await deferredPrompt.userChoice;
      deferredPrompt = null;
      setCanInstall(false);
      return true;
    }
    return false;
  };
  return { canInstall, promptInstall, isIos, isStandalone };
}

export async function enableNotifications() {
  if (typeof Notification === "undefined") return "unsupported";
  if (Notification.permission === "granted") return "granted";
  try { return await Notification.requestPermission(); } catch { return "denied"; }
}

// Visar en OS-notis (via service worker om möjligt). Kräver beviljad behörighet.
export async function notify(title, body) {
  try {
    if (typeof Notification === "undefined" || Notification.permission !== "granted") return;
    const reg = navigator.serviceWorker && (await navigator.serviceWorker.ready);
    const opts = { body, icon: "/icon-192.png", badge: "/icon-192.png", tag: "kr-notif", renotify: true };
    if (reg && reg.showNotification) reg.showNotification(title, opts);
    else new Notification(title, opts);
  } catch { /* ignore */ }
}

export function urlB64ToUint8Array(b64) {
  const padding = "=".repeat((4 - (b64.length % 4)) % 4);
  const base64 = (b64 + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}
